import React from 'react';
import '../nurturer-marketing/styles/marketing.css';
import ContactHero from '../nurturer-marketing/components/ContactHero';
import ContactForm from '../nurturer-marketing/components/ContactForm';
import ContactInfo from '../nurturer-marketing/components/ContactInfo';
import MarketingFooter from '../nurturer-marketing/components/MarketingFooter';

function ContactUsPage() {
  return (
    <div className="nurturer-marketing">
      <ContactHero />
      <section className="contact-body">
        <div className="wrap">
          <div className="grid">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}

export default ContactUsPage;
